export default {"src":"/_next/static/media/blog.4acf1d0d.svg","height":20,"width":16,"blurWidth":0,"blurHeight":0};